var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6751 0H0.000227875C0.000185465 1.33333 0.000185465 2.66667 0.000227875 4H18.6751C22.0298 4 24.7501 6.68667 24.7501 10V22C24.7501 25.3133 22.0298 28 18.6751 28H11.9251V26H16.5533C19.8946 26 22.6036 23.46 22.7228 20.2178C22.7791 18.6489 22.2301 17.16 21.1771 16C22.2301 14.84 22.7791 13.3511 22.7228 11.7822C22.6058 8.54 19.8946 6 16.5556 6H0.000242895C-8.0965e-05 12.6667 -8.0965e-05 19.3333 0.000242895 26H7.87513L7.87513 32C11.4751 32 15.0751 32 18.6751 32C24.2663 32 28.8 27.5222 28.8 22V10C28.8 4.47778 24.2663 0 18.6751 0ZM16.5533 22H11.9251V18H16.6501C17.2036 18 17.7211 18.2178 18.1058 18.6111C18.4906 19.0044 18.6931 19.5267 18.6728 20.0756C18.6346 21.1378 17.6828 22 16.5511 22H16.5533ZM4.05018 22V10H16.5533C17.6851 10 18.6346 10.8644 18.6751 11.9244C18.6953 12.4756 18.4928 12.9956 18.1081 13.3889C17.7233 13.7822 17.2058 14 16.6523 14H7.87738C7.87738 14 7.87738 20.938 7.87738 22H4.05243H4.05018Z",
    fill: "#0B0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.89f80c70fd65f1986b29ba6e96b0177c.svg";
export { ForwardRef as ReactComponent };